export default {
  SET_MAIL_TEMPLATES(state, data) {
    state.mail_templates = data
  },
  SET_SMS_TEMPLATE_FIELDS(state, data) {
    state.mail_template_fields = data.results
  },
  SET_AUTO_MAILS(state, data) {
    state.auto_mails = data
  },
}
